export default __webpack_public_path__ + "static/media/star-solid.8ccc86d6.svg";